module.exports = __webpack_public_path__ + "static/media/22-WaterHeatExchanger - No cool - El heat.05a56f99.png";